export default __webpack_public_path__ + "static/media/overview-bg.7c2e96bb.png";